export function generateDate(date) {
  let day = date.substring(0, 2);
  let month = date.substring(3, 5);
  let year = date.substring(6, 11);
  let houre = date.substring(11, 13);
  let minut = date.substring(14, 16);
  let newDate = new Date(year, month - 1, day, houre, minut);
  return newDate;
}

export function generateStringDate(orgdate) {
  let date = new Date(orgdate);
  let day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
  let year = `${date.getFullYear()}`;
  let timeOptions = { timeStyle: "short" };
  let time = date.toLocaleTimeString("da-DK", timeOptions).replace(".", ":");
  let stringDate = `${day}-${month}-${year} ${time}`;
  return stringDate;
}

export function generateIcalcDate(orgdate) {
  let date = new Date(orgdate);
  let day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
  let year = `${date.getFullYear()}`;
  let timeOptions = { timeStyle: "short" };
  let time = date.toLocaleTimeString("da-DK", timeOptions).replace(".", ":");
  let stringDate = `${day}.${month}.${year} ${time.replace(":", ".")}.00`;
  return stringDate;
}

export function generateStringTime(orgdate) {
  let date = new Date(orgdate);
  let timeOptions = { timeStyle: "short" };
  let time = date.toLocaleTimeString("da-DK", timeOptions).replace(".", ":");
  let stringTime = `${time}`;
  return stringTime;
}

export function generateTagDate(date) {
  let newDate = new Date(date);
  var dateOptions = { year: "numeric", month: "short", day: "numeric" };
  return newDate.toLocaleDateString("da-DK", dateOptions);
}

export function calculateTime(start, end, hour, hours, minute, minutes) {
  let startdate = generateDate(start);
  let enddate = generateDate(end);
  let elapsedMilliseconds = enddate.getTime() - startdate.getTime();
  let elapsedMinuts = Math.floor(elapsedMilliseconds / 60000);

  var elapsedhours = Math.floor(elapsedMinuts / 60);
  var elapsedminutes = elapsedMinuts % 60;
  return `${elapsedhours > 0 ? `${elapsedhours} ${elapsedhours == 1 ? `${hour}` : `${hours}`} ` : ``} ${elapsedminutes > 0 ? `${elapsedminutes} ${elapsedminutes == 1 ? `${minute}` : `${minutes}`}` : ``}`;
}

export function formatDate(date) {
  let newDate = new Date(date);
  var dateOptions = { year: "numeric", month: "short", day: "numeric" };
  return newDate.toLocaleDateString("da-DK", dateOptions);
}

export function formatTime(date) {
  var timeOptions = { timeStyle: "short" };
  return new Intl.DateTimeFormat("da-DK", timeOptions).format(date);
}

export function getYear(date) {
  let newDate = new Date(date);
  return newDate.getFullYear();
}
